<template>
  <v-row light="true">
    <v-col cols="12" v-if="show_export_btn">
      <v-fab-transition
        ><v-btn class="mr-1" color="vtred" @click="exportToPDF" large dark fixed bottom right fab>
          <v-icon>mdi-export</v-icon>
        </v-btn>
      </v-fab-transition>
      <v-fab-transition
        ><v-btn class="mr-1 schedule-btn" color="vtblue" @click="openSchedulingPopup" small fixed right dark>
          Schedule <v-icon small>mdi-account-clock-outline</v-icon>
        </v-btn>
      </v-fab-transition>
    </v-col>
    <v-col :class="{ 'mt-10 mb-4': show_export_btn }" cols="12">
      <v-card :color="`${!show_export_btn ? 'backgroundLight' : ''}`" :class="{ 'mx-2 pa-2': show_export_btn }" flat>
        <v-row v-if="show_export_btn">
          <v-col cols="12">
            <PrimaryFiltersVT
              :list_filters="tabs"
              :current_tab="current_tab"
              @filter_update="update_current_tab($event)"
            >
            </PrimaryFiltersVT>
          </v-col>
        </v-row>
        <v-row align="center" :justify="justify_report">
          <v-col
            :class="{
              'border-doc pa-1': show_export_btn,
              'pa-0': !show_export_btn,
            }"
            cols="auto"
          >
            <div class="container-width backgroundWhite" style="background-color: #ffffff">
              <div ref="header">
                <img height="200" width="794px" id="header" src="/assets/images/header.png" />
              </div>
              <div id="document" ref="document">
                <FleetReport
                  v-if="updated_current_tab == 'Daily Report'"
                  :report_data="fleet_report_data"
                ></FleetReport>
                <KPIReport v-if="updated_current_tab == 'KPI Report'"></KPIReport>
              </div>
              <div ref="footer">
                <img height="50" width="794px" id="footer" src="/assets/images/footer.png" />
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-col>
    <v-overlay class="layering" :value="dialog">
      <v-card
        :light="!this.$vuetify.theme.dark"
        class="backgroundWhite"
        style="width: 80vw; max-height: 80vh; overflow: auto"
      >
        <div class="close-btn">
          <v-btn right @click="closeDialog" outlined color="primaryGrey" class="py-4" x-small>
            <v-icon small color="primaryGrey">mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="pa-0" style="overflow: auto; height: 100%">
          <ReportManagement :isPowerData="isPowerData" />
        </div>
      </v-card>
    </v-overlay>
  </v-row>
</template>

<script>
import html2pdf from "html2pdf.js";
import FleetReport from "../components/FleetReport";
import ReportManagement from "../components/ReportManagement";
import PrimaryFiltersVT from "../components/PrimaryFiltersVT";
import KPIReport from "../components/KPIReport";
import { axios_get } from "../services/vt_service";
import { tracking } from "../services/tracking";

export default {
  name: "Reports",
  components: { FleetReport, ReportManagement, PrimaryFiltersVT, KPIReport },
  data: function () {
    return {
      local_theme: null,
      backup_theme: null,
      fleet_report_data: [],
      dialog: false,
      isPowerData: false,
      tabs: [
        {
          label: "Daily Report",
          value: "Daily Report",
        },
        {
          label: "KPI Report",
          value: "KPI Report",
        },
      ],
      current_tab: "Daily Report",
    };
  },
  mounted() {
    // this.$store.commit("update_page_title", "Report");
    this.get_report_data();
    this.init_theme();
  },
  beforeDestroy() {
    this.revert_theme();
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.deviceId = null;
    },
    init_theme() {
      this.local_theme = localStorage.getItem("theme");
      this.backup_theme = this.local_theme;
      if (this.local_theme === "dark") {
        this.$store.commit("set_dark_mode", false);
        this.$vuetify.theme.dark = this.$store.state.darkMode;
      }
    },
    revert_theme() {
      if (this.backup_theme === "dark") {
        this.$store.commit("set_dark_mode", true);
        this.$vuetify.theme.dark = this.$store.state.darkMode;
      }
    },
    openSchedulingPopup() {
      this.dialog = true;
    },
    update_current_tab(tab) {
      this.current_tab = tab;
    },
    pdfCallback(pdfObject) {
      var pdf_pages = pdfObject.internal.pages;
      var myFooter = "Footer info";
      for (var i = 1; i < pdf_pages.length; i++) {
        // We are telling our pdfObject that we are now working on this page
        pdfObject.setPage(i);
        // The 10,100 value is only for A4 portrait.
        pdfObject.text(myFooter, 10, 100);
      }
    },
    exportToPDF() {
      // this.$store.dispatch(`show_loader`);
      var opt = {
        margin: [1.8, 0, 1, 0],
        filename: "report_" + new Date().toString() + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          scrollX: 0,
          scrollY: 0,
          dpi: 190,
          letterRendering: true,
        },
        jsPDF: { unit: "in", format: "a4", orientation: "p" },
        pagebreak: {
          mode: ["avoid-all", "css", "legacy"],
        },
      };
      html2pdf()
        .from(this.$refs.document)
        .set(opt)
        .toPdf()
        .get("pdf")
        .then(function (pdf) {
          var totalPages = pdf.internal.getNumberOfPages();
          for (var i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.setFontSize(10);
            pdf.setTextColor(150);
            if (i == 1) {
              pdf.addImage(document.getElementById("header"), "png", 0, 0, 8.27, 2);
            }
            pdf.addImage(
              document.getElementById("footer"),
              "png",
              0,
              pdf.internal.pageSize.getHeight() - 0.4,
              8.27,
              0.4
            );
          }
        })
        .save();
      // this.$store.dispatch(`hide_loader`);
    },
    async get_report_data() {
      this.network_error = false;
      this.fleet_report_data = await axios_get(tracking.get_report_data);
    },
  },
  computed: {
    updated_current_tab: function () {
      let tab =
        this.$route.name == "report_fleet"
          ? "Daily Report"
          : this.$route.name == "report_kpi"
          ? "KPI Report"
          : this.current_tab;
      return tab;
    },
    justify_report: function () {
      return this.$route.name == "report_fleet" || this.$route.name == "report_kpi" ? "left" : "center";
    },
    show_export_btn: function () {
      return this.$route.name == "report_fleet" || this.$route.name == "report_kpi" ? false : true;
    },
  },
};
</script>
<style scoped lang="scss">
.container-width {
  width: 794px;
  overflow-x: visible;
  overflow-y: auto;

  ::v-deep a {
    color: #0581c6 !important;
  }
}

.schedule-btn {
  z-index: 9;
}

.border-doc {
  border: 1px solid var(--v-border-base);
}

.close-btn {
  position: absolute;
  right: 0;
  z-index: 9;
  padding: 1em;
}
</style>
